import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "summary"]
  static values = {
    placeholder: String,
    selectedOne: String,
    selectedMany: String
  }

  connect() {
    this.update = this.update.bind(this)
    this.element.addEventListener("itemActivated", this.update)
    this.element.addEventListener("panelClosed", this.update)
    requestAnimationFrame(this.update)
  }

  disconnect() {
    this.element.removeEventListener("itemActivated", this.update)
    this.element.removeEventListener("panelClosed", this.update)
  }

  update() {
    setTimeout(() => {
      const labels = this.selectedLabels()
      this.updateButton(labels)
      this.updateSummary(labels)
    })
  }

  selectedLabels() {
    return (this.element.selectedItems || [])
      .map((item) => item.label?.trim())
      .filter(Boolean)
  }

  updateButton(labels) {
    if (!this.hasLabelTarget) return

    if (labels.length === 0) {
      this.labelTarget.textContent = this.placeholderValue
    } else if (labels.length === 1) {
      this.labelTarget.textContent = labels[0]
    } else {
      this.labelTarget.textContent = this.selectedManyValue.replace("%{count}", labels.length)
    }
  }

  updateSummary(labels) {
    if (!this.hasSummaryTarget) return

    this.summaryTarget.replaceChildren(
      ...labels.map((label) => {
        const chip = document.createElement("span")
        chip.className = "form-field__select-panel-chip"
        chip.textContent = label
        return chip
      })
    )

    this.summaryTarget.hidden = labels.length === 0
  }
}
